"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isCountable(thing) {
    return (typeof thing === 'object');
}
exports.isCountable = isCountable;
